require('./cardMovementsView.scss');
const PropTypes = require('prop-types');

// @ vendor
const React = require('react');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');
const PureRenderMixin = require('react-addons-pure-render-mixin');

// @core
const { formatText } = require('core/i18n').i18n;

// @utilities
const AccessHelper = require('utilities/accessHelper');
const { PAGE_GENERIC, recordPath } = require('utilities/tagging');
const { cardConstants } = require('utilities/accessHelperConditions/cards');
const { cardValidationRules } = require('utilities/accessHelperConditions/cards');
const { contactCenterClassName } = require('utilities/conditionals/conditionalClassname');
const { getLastNChars } = require('utilities/stringHelper');

// @commons
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');

// @actions
const cancelCardPayLaterActions = require('actions/cancelCardPayLater');
const cardTransactionsDownloadActions = require('actions/cardTransactionsDownload');
const cardsAliasActions = require('actions/postCardAlias');
const cardsTransactionsActions = require('actions/getCardsTransactions');
const movementsActions = require('actions/movements');
const openYoungDocumentationActions = require('actions/openYoungDocumentation');
const signaturePatternActions = require('actions/signaturePattern');
const { getECardInformation } = require('actions/eCardInformation');

// @ components
const CardMoreOptionsButton = require('components/cards/cardMoreOptionsButton/cardMoreOptionsButton');
const CardManageOptionsButton = require('components/cards/cardManageOptionsButton/cardManageOptionsButton');
const CardHeaderDetails = require('components/cards/cardHeaderDetails/cardHeaderDetails');
const DetailCharityCard = require('components/cards/detailCharityCard/detailCharityCard');
const CardLastMovements = require('components/cards/cardLastMovements/cardLastMovements');
const OpenYoungCardDocumentationState = require('components/openYoungCardDocumentationState/openYoungCardDocumentationState');
const { LoadingSection } = require('commonsComponents/loadingSection');
const TutorialLauncher = require('components/tutorial/tutorialLauncher');

// @constants
const { CARD_ECARD } = require('constants/index');
const { GRAPHIC_TUTOR_TYPE_3 } = require('constants/index');
const { BUDGET, CHORES, LAVANDA } = require('constants/flagBasedFeatures');


class CardMovementsView extends React.Component {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.onPostAlias = this.onPostAlias.bind(this);
        this.resize = this.resize.bind(this);

        this.state = {
            parentWidth: window.innerWidth
        };
    }

    componentWillMount() {
        const { flagBasedFeatures, immCards, match: { params: { cardId } } } = this.props;

        const immCard = immCards.getIn(['byId', cardId]);

        if (!!immCard) {
            const tagging = flagBasedFeatures.get(LAVANDA) ? `${immCard.getIn(['product', 'type'])}.${immCard.getIn(['product', 'subtype'])}` : immCard.get('tagging');
            recordPath('tarjeta/movimientos', PAGE_GENERIC, '', '', tagging);
        }
    }

    componentDidMount() {
        const { history, validNGOCard, immCards, match: { params: { cardId } }, requestCancelPayLaterInfo } = this.props;
        const immCard = immCards.getIn(['byId', cardId]);

        cardValidationRules.CHARITY_CARD.validator({ immCard }) && validNGOCard(immCard);

        AccessHelper.allowAccess(cardConstants.CARD_MOVEMENTS, { immCard }, history);

        __CONTACT_CENTER__ && requestCancelPayLaterInfo(cardId);
        const type = immCards.getIn(['byId', cardId, 'type']);

        // When we have an eCard, we ask for the eCard information to another
        // service, so we need to know that we are consulting a eCard.

        if (type === CARD_ECARD) {
            this.props.getECardInformation(cardId);
        }

        window.addEventListener('resize', this.resize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.resize);
        this.props.clearFilters(false);
    }

    onPostAlias(value) {
        const { match: { params: { cardId } }, postAlias } = this.props;

        postAlias(cardId, value);
    }

    resize() {
        this.setState({
            parentWidth: window.innerWidth
        });
    }

    render() {
        const {
            clearFilters,
            downloadCardsTransactions,
            flagBasedFeatures,
            getOpenYoungCardDocumentationState,
            getOpenYoungCardDocumentationReset,
            immCancelCardPayLater,
            immCardCharge,
            immCards,
            immCardsTransactionsDownload,
            immMovements,
            immOpenYoungDocumentation,
            immProfile,
            immScreen,
            immTransactions,
            immVariables,
            match: { params: { cardId } },
            requestCardTransactions,
            requestNextCardTransactionsPage,
            resetFilter,
            setTransactionsFilters,
            validateAndExecuteSagas,
            resetScaForCardTransactionsDownload
        } = this.props;

        const immCard = immCards.get('byId').get(cardId);
        let block;
        if (immCard) {
            const immAlias = immCard.get('alias');
            const titleEditable = immAlias.get('isUpdating')
                ? immAlias.get('tentative')
                : immAlias.get('current');
            const type = immCard.get('type');
            const subtitleLeft = formatText(`cards-${type}`);
            const subtitleRight = getLastNChars(immCard.get('number'));
            const mappingBreadcrumb = [
                {
                    text: formatText('breadcrumb-cards'),
                    url: '/myprofile/cards'
                },
                {
                    text: immCard.get('alias').get('current'),
                    url: ''
                }
            ];
            const tutorial = (
                <TutorialLauncher
                    type={GRAPHIC_TUTOR_TYPE_3}
                    title={formatText('tutorials-movementsCardsTitle')}
                />
            );
            const isValidOpenYoungCard = cardValidationRules.CARD_OPEN_YOUNG_MANAGEMENT.validator({ immCard });
            const manageOptionsButton = (
                <CardManageOptionsButton
                    flagBasedFeatures={flagBasedFeatures}
                    immCard={immCard}
                    cardId={cardId}
                    immCancelCardPayLater={__CONTACT_CENTER__ ? immCancelCardPayLater : null}
                />
            )
            const showManageOptionsBtn = isValidOpenYoungCard && (flagBasedFeatures.get(BUDGET) || flagBasedFeatures.get(CHORES));
            const isCharity = immCard.get('isCharity')
                ?
                (
                    <DetailCharityCard
                        immCard={immCard}
                        isSolidarity={immMovements.get('hasNGOsMovement')}
                    />
                )
                : null;


            const cardMoreOptionsButton = (<CardMoreOptionsButton
                cardId={cardId}
                flagBasedFeatures={flagBasedFeatures}
                immCard={immCard}
                immCancelCardPayLater={__CONTACT_CENTER__ ? immCancelCardPayLater : null}
            />);

            let cardMoreOptionsButtonMobile;
            let cardMoreOptionsButtonDesktop;

            if (immScreen.get('isMobile')) {
                cardMoreOptionsButtonMobile = cardMoreOptionsButton;
            } else {
                cardMoreOptionsButtonDesktop = cardMoreOptionsButton;
            }

            const cardMovementsBodyClassName = contactCenterClassName('card-movements__body', 'grid-view__body')
            const cardMovementsContainerClassName = contactCenterClassName('card-movements__container', 'container-fluid')

            let openYoungCardDocumentationState;

            if (immCard.get('status') !== 'BLOQUEADO' &&
                immCard.get('isOpenYoung') &&
                flagBasedFeatures.get('status-documentation-openyoung-enabled')) {
                openYoungCardDocumentationState = (
                    <OpenYoungCardDocumentationState
                        getCardDocumentationState={getOpenYoungCardDocumentationState}
                        getCardDocumentationReset={getOpenYoungCardDocumentationReset}
                        immCard={immCard}
                        immOpenYoungDocumentation={immOpenYoungDocumentation}
                        immVariables={immVariables}
                    />
                );
            }

            block = (
                <div>
                    <div className="container-fluid card-movements--header-identifier">
                        <div className="row">
                            <OKCover size="medium" section="cards" customClass="col-xs-12">
                                <OKHeaderSubPage
                                    breadcrumbConfig={mappingBreadcrumb}
                                    subtitleLeft={subtitleLeft}
                                    subtitleRight={subtitleRight}
                                    titleIsEditable={__CONTACT_CENTER__ ? false : true}
                                    titleEditable={titleEditable}
                                    titleEditableAction={this.onPostAlias}
                                    finalTitle={!__CONTACT_CENTER__ ? undefined : titleEditable}
                                    tutorial={tutorial}
                                    hasTitle={__CONTACT_CENTER__ ? this.state.parentWidth > 1024 : undefined}
                                >
                                    <div>
                                        {cardMoreOptionsButtonMobile}
                                        <CardHeaderDetails
                                            immCard={immCard}
                                            isFetching={immCardCharge.get('isFetching')}
                                            rightSpace={true}
                                            flagBasedFeatures={flagBasedFeatures}
                                        />
                                        {isCharity}
                                        {cardMoreOptionsButtonDesktop}
                                        {
                                            showManageOptionsBtn &&
                                            manageOptionsButton
                                        }
                                    </div>
                                </OKHeaderSubPage>
                            </OKCover>
                        </div>
                    </div>
                    <div className={cardMovementsBodyClassName}>
                        <div className={cardMovementsContainerClassName}>
                            <div className="row grid-view--content-position-negative">
                                <div className="col-md-12">
                                    {openYoungCardDocumentationState}
                                    <CardLastMovements
                                        clearFilters={clearFilters}
                                        downloadCardsTransactions={downloadCardsTransactions}
                                        flagBasedFeatures={flagBasedFeatures}
                                        immCard={immCard}
                                        immCardsTransactionsDownload={immCardsTransactionsDownload}
                                        resetScaForCardTransactionsDownload={resetScaForCardTransactionsDownload}
                                        immFilters={immTransactions.get('filters')}
                                        immProfile={immProfile}
                                        immTransactions={immTransactions.get(cardId)}
                                        requestCardTransactions={requestCardTransactions}
                                        requestNextCardTransactionsPage={requestNextCardTransactionsPage}
                                        resetFilter={resetFilter}
                                        setTransactionsFilters={setTransactionsFilters}
                                        validateAndExecuteSagas={validateAndExecuteSagas}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            block = <LoadingSection />;
        }

        return block;
    }
}

CardMovementsView.propTypes = {
    clearFilters: PropTypes.func.isRequired,
    downloadCardsTransactions: PropTypes.func.isRequired,
    flagBasedFeatures: PropTypes.object,
    getECardInformation: PropTypes.func.isRequired,
    getOpenYoungCardDocumentationState: PropTypes.func.isRequired,
    getOpenYoungCardDocumentationReset:PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immCancelCardPayLater: PropTypes.object.isRequired,
    immCardCharge: PropTypes.object.isRequired,
    immCards: PropTypes.object.isRequired,
    immCardsTransactionsDownload: PropTypes.object.isRequired,
    immMovements: PropTypes.object,
    immOpenYoungDocumentation: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    immScreen: PropTypes.object.isRequired,
    immTransactions: PropTypes.object.isRequired,
    immVariables: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    postAlias: PropTypes.func.isRequired,
    requestCancelPayLaterInfo: PropTypes.func,
    requestCardTransactions: PropTypes.func.isRequired,
    requestNextCardTransactionsPage: PropTypes.func.isRequired,
    resetFilter: PropTypes.func.isRequired,
    setTransactionsFilters: PropTypes.func.isRequired,
    validNGOCard: PropTypes.func.isRequired,
    validateAndExecuteSagas: PropTypes.func.isRequired,
    resetScaForCardTransactionsDownload: PropTypes.func.isRequired
};

module.exports.constructor = CardMovementsView;
module.exports.CardMovementsView = connect(
    state => ({
        flagBasedFeatures: state.flagBasedFeatures,
        immCancelCardPayLater: state.cancelCardPayLater,
        immCards: state.cards,
        immCardCharge: state.cardCharge,
        immCardsTransactionsDownload: state.cardsTransactionsDownload,
        immOpenYoungDocumentation: state.openYoungDocumentation,
        immScreen: state.screen,
        immProfile: state.profile,
        immTransactions: state.cardsTransactions,
        immVariables: state.globalVariables.getIn(['variables', 'parameters']),
        immMovements: state.movements,
    }),
    {
        clearFilters: cardsTransactionsActions.clearCardTransactionsFilters,
        downloadCardsTransactions: cardTransactionsDownloadActions.downloadCardsTransactions,
        resetScaForCardTransactionsDownload: cardTransactionsDownloadActions.resetScaForCardTransactionsDownload,
        getECardInformation: getECardInformation,
        getOpenYoungCardDocumentationState: openYoungDocumentationActions.getCardDocumentationState,
        getOpenYoungCardDocumentationReset: openYoungDocumentationActions.getCardDocumentationDataReset,
        postAlias: cardsAliasActions.postCardAlias,
        requestCancelPayLaterInfo: cancelCardPayLaterActions.requestCancelPayLaterInfo,
        requestCardTransactions: cardsTransactionsActions.requestCardTransactions,
        requestNextCardTransactionsPage: cardsTransactionsActions.requestNextCardTransactionsPage,
        resetFilter: cardsTransactionsActions.resetCardTransactionsFilter,
        setTransactionsFilters: cardsTransactionsActions.setTransactionsFilters,
        validNGOCard: movementsActions.validNGOCard,
        validateAndExecuteSagas: signaturePatternActions.validateAndExecuteSagas,
    }
)(withRouter(CardMovementsView));
